<template>
  <v-dialog
    v-model="opened"
    content-class="rating-configurator-dialog"
    max-width="350"
    persistent
  >
    <h3 class="rating-configurator-dialog__title">
      {{ title }}
    </h3>

    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <v-form ref="rating-configurator" class="mt-4" @submit.prevent="onSubmit">
      <v-text-field
        v-model="formData.name"
        :rules="nameRules"
        :label="categoryName"
        outlined
        dense
      />
      <div class="rating-configurator-dialog__rating">
        <div class="rating-configurator-dialog__rating-label">
          Рейтинг
        </div>

        <div class="rating-configurator-dialog__rating-input">
          <v-slider v-model="formData.score" min="1" max="10" tick-size="5" />
          <v-text-field v-model="formData.score" outlined dense readonly />
        </div>
      </div>

      <v-btn
        elevation="0"
        color="warning"
        type="submit"
        block
        :loading="loading"
      >
        {{ $t('common.btns.save') }}
      </v-btn>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    categoryName: {
      type: String,
      default: '',
    },
    onlyNumbersName: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number,
      required: true,
    },
    editData: {
      type: [Object, null],
      default: null,
    },
  },
  data: () => ({
    loading: false,

    formData: {
      name: '',
      score: 1,
    },
  }),
  watch: {
    opened(val) {
      if (!val) {
        this.formData.name = '';
        this.formData.score = 1;
        this.$refs['rating-configurator'].resetValidation();
        return;
      }

      if (this.editData) {
        this.formData.name = this.editData.name;
        this.formData.score = this.editData.score;
      }
    },
  },
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    title() {
      if (this.editData) {
        return `${this.$t('common.btns.edit')} "${this.editData.name}"`;
      }

      return `${this.$t('common.button.add')} "${this.categoryName}"`;
    },
    nameRules() {
      const rules = [this.isRequired];

      if (this.onlyNumbersName) {
        rules.push(this.onlyNumbers);
      }

      return rules;
    },
  },
  methods: {
    isRequired(v) {
      return !!v || this.$t('common.fields.validation.field.required');
    },
    onlyNumbers(v) {
      if (!v) return true;
      if (Number(v) > 100) {
        return `${this.$t('common.fields.validation.max')} 100`;
      }

      return (
        /^[0-9]{1,12}$/.test(v) || this.$t('common.fields.validation.numbers')
      );
    },
    async onSubmit() {
      const isValid = this.$refs['rating-configurator'].validate();

      if (!isValid) return;

      this.loading = true;

      const actionName = this.editData ? 'updateItem' : 'addNew';

      const result = await this[actionName]();

      if (result.success) this.opened = false;

      this.loading = false;
      this.$emit('updated', result);
    },
    async addNew() {
      const result = await this.$store.dispatch(
        'driver/addRatingConfiguration',
        {
          ...this.formData,
          type: this.type,
        },
      );

      return result;
    },
    async updateItem() {
      const result = await this.$store.dispatch(
        'driver/updateRatingConfiguration',
        {
          id: this.editData.id,
          params: {
            ...this.formData,
            type: this.type,
          },
        },
      );

      return result;
    },
  },
};
</script>

<style lang="scss">
.rating-configurator-dialog {
  padding: 10px;
  background-color: #fff;

  &__rating {
    &-label {
      font-size: 14px;
      margin-left: 3px;
      color: #333;
    }

    &-input {
      display: flex;
      align-items: center;
    }

    .v-text-field {
      max-width: 50px;
      margin-left: 10px;
    }

    .v-slider__thumb {
      cursor: pointer;

      &::before {
        max-width: 20px;
        max-height: 20px;
        left: 50% !important;
        top: 50% !important;
        transform: translate(-50%, -50%) !important;
      }

      &:hover::before,
      &:active::before {
        max-width: 30px;
        max-height: 30px;
        left: 50% !important;
        top: 50% !important;
        transform: translate(-50%, -50%) !important;
      }
    }
  }
}
</style>
